import { RouteConfig } from 'vue-router'

function buildRoutes(_month: string, _title = '') {
  const Index = () => import(`../activity/koi-fish/${_month}/Index.vue`)
  const Order = () => import(`../activity/koi-fish/${_month}/Order.vue`)
  const Product = () => import(`../activity/koi-fish/${_month}/Product.vue`)
  const Rewards = () => import(`../activity/koi-fish/${_month}/Rewards.vue`)
  const WeeklyRewards = () => import(`../activity/koi-fish/${_month}/WeeklyRewards.vue`)

  const monthForName = _month.split('-').join('_')

  const indexRoute: RouteConfig = {
    path: `/activity/koi-fish/${_month}`,
    name: `activity_koi_fish_${monthForName}`,
    component: Index,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: _title,
    },
  }

  const orderRoute: RouteConfig = {
    path: `/activity/koi-fish/${_month}/order`,
    name: `activity_koi_fish_${monthForName}_order`,
    component: Order,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '订单详情',
    },
  }

  const productRoute: RouteConfig = {
    path: `/activity/koi-fish/${_month}/product`,
    name: `activity_koi_fish_${monthForName}_product`,
    component: Product,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '商品详情',
    },
  }

  const rewardsRoute: RouteConfig = {
    path: `/activity/koi-fish/${_month}/rewards`,
    name: `activity_koi_fish_${monthForName}_rewards`,
    component: Rewards,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '我的奖品',
    },
  }

  const weeklyRewardsRoute: RouteConfig = {
    path: `/activity/koi-fish/${_month}/weekly-rewards`,
    name: `activity_koi_fish_${monthForName}_weekly_rewards`,
    component: WeeklyRewards,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '奖励详情',
    },
  }

  return [indexRoute, orderRoute, productRoute, rewardsRoute, weeklyRewardsRoute]
}

export default [...buildRoutes('2025-05', '初夏趣运动 锦鲤天天抽'), ...buildRoutes('2025-06', '六月嘉年华 锦鲤天天抽')]
